// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1j8Uu","row":"styles_row__2rDmm"};